import { Injectable } from '@angular/core';
import { CATALOG_CODE, CatalogCodeType } from '../../../../../shared/constants/catalog-codes';
import { AbstractCatalogOptionLoader } from './catalog-option-loader.service';

@Injectable()
export class PumpOptionLoader extends AbstractCatalogOptionLoader {
  getCatalogType(): CatalogCodeType {
    return CATALOG_CODE.PUMP_CAPACITY;
  }
}
